import React from 'react'
import { Pagination } from 'react-bootstrap'

function Paginations({ total, currentPage, onPageChange }) {
  let items = [];

  for (let number = 1; number <= total; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => onPageChange(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <Pagination size="md">{items}</Pagination>
    </div>
  )
}

export default Paginations
